import { compareStrings } from '../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { getLabelByExclusionType } from '../../../../../../utils/uiSettings/contentControl/content-control.values';
import { ContentControlDataProtectionExclusionFrontendFields } from '../GzContentControlDataProtectionExclusionsGridDataProvider';

// sort by column type
export function sortByColumn(
  item1: ContentControlDataProtectionExclusionFrontendFields,
  item2: ContentControlDataProtectionExclusionFrontendFields,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.TYPE:
      return compareStrings(getLabelByExclusionType(item1.type), getLabelByExclusionType(item2.type), direction);

    case ColumnKeys.ADDRESS:
      return compareStrings(item1.address, item2.address, direction);

    case ColumnKeys.RULES_TO_CONSIDER:
      return compareStrings(item1.rulesToConsiderString, item2.rulesToConsiderString, direction);
  }

  return 0;
}
